import { Col } from 'reactstrap';
import styled from 'styled-components';
import {
    getTheme,
    size
} from 'mol-ui';

export const ButtonDiv = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    height: 80px;
`;

export const ColRight = styled(Col)`
    align-items: center;
    display: flex;
    justify-content: flex-end;
`;

export const ContainerStyled = styled.div`
    padding: 10px;
    ${ size.xs(`
        padding-top: 20px;
    `) };
`;

export const ControllerContainer = styled.div`
    padding: 10px;
    width: 100%;
`;

export const ItemContainer = styled.div`
    border-bottom: 1px solid ${ getTheme('textColor') };
    color: ${ getTheme('textColor') };
    display: flex;
    flex-direction: column;
    padding: 5px;
`;

export const ItemText = styled.div`
    font-size: 10px;
    padding: 0px 5px;
`;

export const ItemTitle = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    padding: 0px 5px;
    gap: 5px;
`;

export const TableContent = styled.div `
    border: 1px solid ${ getTheme('textColor') };
`;
